<template>
  <ion-modal :is-open="isOpen" :backdrop-dismiss="false" class="insufficient-stock-modal">
    <div class="modal-content">
      <div class="icon-container">
        <ion-icon :icon="alertCircleOutline" class="alert-icon"></ion-icon>
      </div>

      <h2>Stok Tidak Mencukupi</h2>
      <p class="description">
        Maaf, {{ items && items.length === 1 ? 'menu berikut' : 'beberapa menu berikut' }} tidak tersedia atau stoknya telah habis:
      </p>

      <div class="stock-items-list">
        <div v-for="item in items" :key="item.id || item.name" class="stock-item-card">
          <img 
            :src="item.photo || 'https://res.cloudinary.com/dxcleuxwe/image/upload/v1758687442/placeholder/no-product-image_v7tdrr.png'" 
            class="item-img" 
            alt="Product"
          />
          <div class="item-info">
            <span class="item-name">{{ item.name }}</span>
          </div>
          <span class="stock-badge">Stok Habis</span>
        </div>
      </div>

      <div class="modal-actions">
        <ion-button @click="onEditOrder" expand="block" class="btn-primary">
          <ion-icon slot="start" :icon="arrowBackOutline"></ion-icon>
          Ubah Pesanan
        </ion-button>
        <ion-button @click="onClose" expand="block" fill="clear" class="btn-close">
          Tutup
        </ion-button>
      </div>
    </div>
  </ion-modal>
</template>

<script>
import { IonModal, IonIcon, IonButton } from '@ionic/vue';
import { alertCircleOutline, arrowBackOutline } from 'ionicons/icons';

export default {
  name: 'InsufficientStockModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    IonModal,
    IonIcon,
    IonButton
  },
  setup() {
    return {
      alertCircleOutline,
      arrowBackOutline
    };
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onEditOrder() {
      this.$emit('edit-order');
    }
  }
};
</script>

<style scoped>
ion-modal.insufficient-stock-modal {
  --height: auto;
  --width: 90%;
  --max-width: 400px;
  --border-radius: 24px;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.35);
}

.modal-content {
  padding: 24px 20px 20px 20px;
  text-align: center;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 24px;
}

.icon-container {
  background: #fee2e2;
  border-radius: 50%;
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.alert-icon {
  font-size: 36px;
  color: #ef4444;
}

h2 {
  font-weight: 800;
  color: #1f2937;
  font-size: 1.25rem;
  margin: 0 0 8px 0;
}

.description {
  color: #6b7280;
  font-size: 0.9rem;
  margin: 0 0 16px 0;
  line-height: 1.4;
}

.stock-items-list {
  width: 100%;
  max-height: 220px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
  padding-right: 4px;
}

/* Scrollbar styling */
.stock-items-list::-webkit-scrollbar {
  width: 4px;
}
.stock-items-list::-webkit-scrollbar-thumb {
  background: #e5e7eb;
  border-radius: 4px;
}

.stock-item-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: 14px;
  padding: 10px 12px;
  text-align: left;
}

.item-img {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
  background-color: #e5e7eb;
}

.item-info {
  flex: 1;
  min-width: 0;
}

.item-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #111827;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stock-badge {
  background: #fee2e2;
  color: #dc2626;
  font-size: 0.725rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.modal-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.btn-primary {
  --background: #111827;
  --background-activated: #1f2937;
  --border-radius: 12px;
  font-weight: 700;
  text-transform: none;
  font-size: 0.95rem;
  height: 48px;
  margin: 0;
}

.btn-close {
  --color: #6b7280;
  font-weight: 600;
  text-transform: none;
  font-size: 0.9rem;
  height: 40px;
  margin: 0;
}
</style>
